import React from "react";
import { getPagination } from "./include/pagination";

const Pagination = ({
    currentPage,
    totalPages,
    totalRecords = 0,
    onPageChange
}) => {

    const visiblePages = getPagination(currentPage, totalPages);

    if (totalPages <= 1) return null;

    return (
        <div className="grid grid-cols-3 items-center w-full mt-8">

            {/* Left */}
            <div></div>
            {/* <div className="col-span-12 md:col-span-2 text-center md:text-left">

                <div className="flex items-center gap-2">

                    <span>Go to:</span>

                    <select
                        className="input"
                        style={{ width: "90px" }}
                        value={currentPage}
                        onChange={(e) => onPageChange(Number(e.target.value))}
                    >
                        {Array.from({ length: totalPages }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {i + 1}
                            </option>
                        ))}
                    </select>

                </div>

            </div> */}

            {/* Center */}

            <div className="flex items-center justify-center gap-2">
                <button
                    className="button"
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    Previous
                </button>

                {visiblePages.map((page, index) =>
                    page === "..." ? (
                        <span key={index}>...</span>
                    ) : (
                        <button
                            key={page}
                            className={`button ${page === currentPage ? "blue" : ""}`}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </button>
                    )
                )}

                <button
                    className="button"
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    Next
                </button>

            </div>

            {/* Right */}
            <div className="text-right">
                <span className="whitespace-nowrap">
                    Page {currentPage} of {totalPages}
                </span>

            </div>

        </div>
    );
};

export default Pagination;